import React, { useContext, useState, useEffect } from 'react';
import { Button, Icon, Text, Tooltip, theme } from 'components';
import styled from 'styled-components';
import AnsweringSearchContext from './AnsweringSearchContext';

const MlsStaffRightHeader = () => {
  const { selectedTab, total, initialTotal, csvLink, isLoading } = useContext(
    AnsweringSearchContext,
  );

  return (
    <StyledContainer>
      {!isLoading && (
        <StyledText data-count={total} data-total={initialTotal}>
          {total} of {initialTotal} {selectedTab}
        </StyledText>
      )}
      <Tooltip
        title="Can only export up to 50 pages from the current page."
        placement="topRight"
        data-cy="mls-staff-tooltip"
      >
        <StyledButton
          data-cy="export-button"
          href={csvLink}
          rel="noopener noreferrer"
          target="_blank"
        >
          <StyledIcon type="antdExportOutlined" color="white" width={11} />{' '}
          Export
        </StyledButton>
      </Tooltip>
    </StyledContainer>
  );
};

export default MlsStaffRightHeader;

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-bottom: 5px;
`;

const StyledText = styled(Text)`
  color: ${theme.textColorSecondary};
  font-size: 14px;
`;

const StyledIcon = styled(Icon)`
  margin-top: 1px;
`;

const StyledButton = styled(Button)`
  color: white;
  background-color: ${theme.blue6};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 3px !important;
  font-size: 14px;
`;
